{
  "version": 1,
  "source": {
    "image": "docs/reference/cornelis-anthonisz-1538.jpg",
    "width": 2000,
    "height": 1454
  },
  "method": {
    "topHatPx": 9,
    "fieldBlurSigmaPx": 3,
    "fieldClasses": ["nearFields", "polderFields", "farFields", "gardenGrass"],
    "labelStepPx": 2,
    "erodePx": 12,
    "tilePx": 160,
    "tileStridePx": 80,
    "minTileCover": 0.4,
    "minFit": 0.12,
    "minSpacingPx": 8,
    "minPeriodicity": 0.15,
    "agreeDeg": 10,
    "minTiles": 3
  },
  "polders": {
    "polder-3-3-1": {
      "survey": {
        "ditchAngle": 0.5612,
        "ditchSpacing": 75.9
      },
      "tiles": 12,
      "resolved": 7,
      "agreeing": 7,
      "painting": {
        "angleDeg": 1.3,
        "spacingPx": 17.2
      },
      "painter": {
        "ditchAngle": 2.1402,
        "ditchSpacing": 31.4
      },
      "polygon": [
        [-270.2, 0],
        [-1683.6, 0],
        [-1714.1, -52.9],
        [-1743.5, -127.7],
        [-2000, -570],
        [-2000, -2000],
        [-406.8, -2000],
        [-411.4, -1822.7],
        [-396.2, -1498.1],
        [-389.3, -1467.7],
        [-357.1, -1423.6],
        [-350.7, -1428.4],
        [-381.9, -1471.1],
        [-388.2, -1499.1],
        [-403.4, -1822.7],
        [-398.8, -2000],
        [0, -2000],
        [0, -697.9],
        [-68.3, -698],
        [-164.4, -675.7],
        [-191.5, -660],
        [-228.2, -626],
        [-330.9, -490.1],
        [-287.4, -93.1]
      ]
    },
    "polder-3-4-4": {
      "survey": {
        "ditchAngle": 0.1803,
        "ditchSpacing": 75.9
      },
      "tiles": 24,
      "resolved": 21,
      "agreeing": 21,
      "painting": {
        "angleDeg": 6,
        "spacingPx": 17
      },
      "painter": {
        "ditchAngle": 2.3185,
        "ditchSpacing": 29.5
      },
      "polygon": [
        [-590.8, 1079.7],
        [-568.5, 1081.5],
        [-527.8, 1016.1],
        [-553.3, 1011.8],
        [-590.8, 1025.7],
        [-590.8, 0],
        [-270.2, 0],
        [-233.8, 154.7],
        [0, 510.9],
        [0, 668.5],
        [-56.2, 681.2],
        [-182.7, 731.2],
        [-590.8, 1102.2]
      ]
    },
    "polder-3-4-5": {
      "survey": {
        "ditchAngle": 0.1803,
        "ditchSpacing": 75.9
      },
      "tiles": 4,
      "resolved": 3,
      "agreeing": 3,
      "painting": {
        "angleDeg": 7.8,
        "spacingPx": 20.7
      },
      "painter": {
        "ditchAngle": 2.4016,
        "ditchSpacing": 37.3
      },
      "polygon": [
        [-590.8, 2000],
        [-794.7, 2000],
        [-794.7, 1389.7],
        [-789.7, 1404.6],
        [-775.3, 1400.4],
        [-780.5, 1382.3],
        [-794.7, 1369.5],
        [-794.7, 855.2],
        [-706.8, 870.1],
        [-663.6, 694.1],
        [-794.7, 664],
        [-794.7, 0],
        [-590.8, 0],
        [-590.8, 1025.7],
        [-634.8, 1034.9],
        [-641.1, 1050.4],
        [-619.7, 1072.1],
        [-590.8, 1079.7],
        [-590.8, 1102.2],
        [-650.8, 1157],
        [-672, 1192.3],
        [-742.4, 1229.4],
        [-739.8, 1234.8],
        [-667.8, 1196.7],
        [-646, 1160.8],
        [-590.8, 1110.3]
      ]
    },
    "polder-4-3-1": {
      "survey": {
        "ditchAngle": 0.5758,
        "ditchSpacing": 45.3
      },
      "tiles": 7,
      "resolved": 4,
      "agreeing": 4,
      "painting": {
        "angleDeg": 76.5,
        "spacingPx": 52.7
      },
      "painter": {
        "ditchAngle": 0.668,
        "ditchSpacing": 47.3
      },
      "polygon": [
        [1011.1, -2000],
        [2000, -2000],
        [2000, -663.4],
        [1369.3, -298.9],
        [953.5, -131.8],
        [778.3, -248.3],
        [778.3, -551.3],
        [802.3, -565.1],
        [787.7, -590.5],
        [778.3, -585.1],
        [778.3, -1293.1],
        [865, -1533.9],
        [986.2, -1949.7]
      ]
    },
    "polder-4-3-2": {
      "survey": {
        "ditchAngle": 0.5758,
        "ditchSpacing": 45.3
      },
      "tiles": 6,
      "resolved": 4,
      "agreeing": 4,
      "painting": {
        "angleDeg": 36.5,
        "spacingPx": 25
      },
      "painter": {
        "ditchAngle": 3.0998,
        "ditchSpacing": 41.7
      },
      "polygon": [
        [0, -2000],
        [904, -2000],
        [774, -1564.7],
        [730.8, -1458.7],
        [683.5, -1272.8],
        [710.4, -1241.9],
        [693.3, -1184.4],
        [663.2, -1162.1],
        [527.1, -741.8],
        [427.9, -682.9],
        [204.5, -667.6],
        [127.8, -670.8],
        [92.2, -656.1],
        [52.9, -692.9],
        [0, -697.9]
      ]
    }
  }
}
